export const generateCorrelationId = (length) => {
  var result = '';
  var base32Characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';
  var charactersLength = base32Characters.length;
  for (var i = 0; i < length; i++) {
    result += base32Characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
